import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';
import { ApplicationPaths } from 'authorization/ApiAuthorizationConstants';
import Loader from 'components/Loader';
import { isUserAuthorized } from './roles-check';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children, allowedGroups }: GuardProps) => {
    const { authService, user } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!authService) return;

        authService.isAuthenticated().then((isLoggedIn) => {
            if (!isLoggedIn) {
                navigate(ApplicationPaths.Login, {
                    state: {
                        from: location.pathname,
                    },
                    replace: true,
                });
            } else {
                setLoading(false);
            }
        });
    }, [navigate, location, authService]);

    useEffect(() => {
        if (!isUserAuthorized(user, allowedGroups)) {
            navigate('unauthorized', { replace: true });
        }
    }, [allowedGroups, navigate, user]);

    if (loading) return <Loader />;

    return children;
};

export default AuthGuard;
